var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    clipPath: "url(#clip0_978_3377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0329 2.48399H9.45124C9.10054 2.48399 8.7642 2.62331 8.51621 2.8713C8.26822 3.11928 8.12891 3.45562 8.12891 3.80633V9.42799L20.0329 16.372L25.9849 18.8837L31.9369 16.372V9.42799L20.0329 2.48399Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.12891 9.42799H20.0329V16.372H8.12891V9.42799Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.6129 2.48399H20.0312V9.42799H31.9352V3.80633C31.9352 3.45562 31.7959 3.11928 31.5479 2.8713C31.3 2.62331 30.9636 2.48399 30.6129 2.48399Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.0329 16.372H8.12891V28.9377C8.12891 29.2884 8.26822 29.6247 8.51621 29.8727C8.7642 30.1207 9.10054 30.26 9.45124 30.26H30.6146C30.9653 30.26 31.3016 30.1207 31.5496 29.8727C31.7976 29.6247 31.9369 29.2884 31.9369 28.9377V23.316L20.0329 16.372Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.0312 16.372H31.9352V23.316H20.0312V16.372Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.1,
    d: "M16.7266 7.44398H8.12891V26.292H16.7266C17.077 26.2909 17.4127 26.1513 17.6604 25.9035C17.9082 25.6558 18.0479 25.32 18.0489 24.9696V8.76632C18.0479 8.41594 17.9082 8.0802 17.6604 7.83244C17.4127 7.58469 17.077 7.44503 16.7266 7.44398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M15.7346 8.43599H8.12891V27.284H15.7346C16.085 27.2829 16.4207 27.1433 16.6684 26.8955C16.9162 26.6478 17.0559 26.312 17.0569 25.9617V9.75833C17.0559 9.40794 16.9162 9.07221 16.6684 8.82445C16.4207 8.57669 16.085 8.43704 15.7346 8.43599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.2,
    d: "M15.7346 8.43599H8.12891V25.3H15.7346C16.085 25.2989 16.4207 25.1593 16.6684 24.9115C16.9162 24.6638 17.0559 24.328 17.0569 23.9777V9.75833C17.0559 9.40794 16.9162 9.07221 16.6684 8.82445C16.4207 8.57669 16.085 8.43704 15.7346 8.43599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.2,
    d: "M14.7426 8.43599H8.12891V25.3H14.7426C15.093 25.2989 15.4287 25.1593 15.6764 24.9115C15.9242 24.6638 16.0639 24.328 16.0649 23.9777V9.75833C16.0639 9.40794 15.9242 9.07221 15.6764 8.82445C15.4287 8.57669 15.093 8.43704 14.7426 8.43599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Back Plate",
    d: "M1.51374 8.43599H14.7411C15.0918 8.43599 15.4281 8.57531 15.6761 8.82329C15.9241 9.07128 16.0634 9.40762 16.0634 9.75833V22.9857C16.0634 23.3364 15.9241 23.6727 15.6761 23.9207C15.4281 24.1687 15.0918 24.308 14.7411 24.308H1.51374C1.16304 24.308 0.826696 24.1687 0.578709 23.9207C0.330723 23.6727 0.191406 23.3364 0.191406 22.9857L0.191406 9.75833C0.191406 9.40762 0.330723 9.07128 0.578709 8.82329C0.826696 8.57531 1.16304 8.43599 1.51374 8.43599Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M3.69531 21.332L6.90542 16.3581L3.96514 11.412H6.33106L7.93611 14.5735C8.08359 14.8731 8.1851 15.0966 8.24066 15.2441H8.26149C8.3673 15.0047 8.47807 14.7719 8.59381 14.5457L10.309 11.412H12.4805L9.46478 16.3303L12.5568 21.332H10.2455L8.39144 17.86C8.30409 17.7121 8.23006 17.5567 8.17022 17.3957H8.14245C8.08834 17.5532 8.01645 17.7039 7.92818 17.8451L6.02056 21.332H3.69531Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_978_3377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.7ccdfe6e669c43b9385554fc1660b037.svg";
export { ForwardRef as ReactComponent };